'use client';

import { useState } from 'react';
import Link from 'next/link';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';

export default function ContactPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // API call will go here
        await new Promise(resolve => setTimeout(resolve, 1500));
        console.log('Contact form:', formData);

        setIsSubmitting(false);
        setIsSubmitted(true);
    };

    const contactInfo = [
        {
            icon: '📍',
            title: 'Office Address',
            content: '123 Real Estate Tower, Anna Salai, Chennai - 600002, Tamil Nadu',
        },
        {
            icon: '📧',
            title: 'Email Us',
            content: 'support@dreamacres.com',
            link: 'mailto:support@dreamacres.com',
        },
        {
            icon: '📞',
            title: 'Call Us',
            content: '+91 98765 43210',
            link: 'tel:+919876543210',
        },
        {
            icon: '⏰',
            title: 'Working Hours',
            content: 'Mon - Sat: 9:00 AM - 7:00 PM',
        },
    ];

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-gray-50">
                {/* Header */}
                <section className="bg-gradient-to-br from-primary to-primary-dark text-white py-16">
                    <div className="container-custom">
                        <nav className="flex items-center gap-2 text-sm text-white/70 mb-6">
                            <Link href="/" className="hover:text-white">Home</Link>
                            <span>→</span>
                            <span className="text-white">Contact Us</span>
                        </nav>
                        <h1 className="text-3xl lg:text-4xl font-bold mb-4">
                            Get in Touch
                        </h1>
                        <p className="text-white/80 max-w-xl">
                            Have a question or need assistance? Our team is here to help you
                            with all your real estate needs.
                        </p>
                    </div>
                </section>

                <section className="py-16">
                    <div className="container-custom">
                        <div className="grid lg:grid-cols-3 gap-8">
                            {/* Contact Form */}
                            <div className="lg:col-span-2">
                                <div className="bg-white rounded-xl p-6 lg:p-8 shadow-sm">
                                    {isSubmitted ? (
                                        <div className="text-center py-12">
                                            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-success/10 flex items-center justify-center">
                                                <svg className="w-10 h-10 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                </svg>
                                            </div>
                                            <h3 className="text-2xl font-bold text-gray-900 mb-2">Thank You!</h3>
                                            <p className="text-gray-600 mb-6">
                                                Your message has been sent successfully. We'll get back to you shortly.
                                            </p>
                                            <button
                                                onClick={() => {
                                                    setIsSubmitted(false);
                                                    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
                                                }}
                                                className="btn btn-secondary"
                                            >
                                                Send Another Message
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <h2 className="text-xl font-bold text-gray-900 mb-6">Send us a Message</h2>
                                            <form onSubmit={handleSubmit} className="space-y-5">
                                                <div className="grid sm:grid-cols-2 gap-5">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Your Name *</label>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                            placeholder="Enter your name"
                                                            className="input"
                                                            required
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            placeholder="Enter your email"
                                                            className="input"
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="grid sm:grid-cols-2 gap-5">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                                                        <input
                                                            type="tel"
                                                            name="phone"
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                            placeholder="Enter phone number"
                                                            className="input"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">Subject *</label>
                                                        <select
                                                            name="subject"
                                                            value={formData.subject}
                                                            onChange={handleChange}
                                                            className="input select"
                                                            required
                                                        >
                                                            <option value="">Select subject</option>
                                                            <option value="buying">Property Buying</option>
                                                            <option value="selling">Property Selling</option>
                                                            <option value="renting">Renting</option>
                                                            <option value="support">Technical Support</option>
                                                            <option value="other">Other</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">Your Message *</label>
                                                    <textarea
                                                        name="message"
                                                        value={formData.message}
                                                        onChange={handleChange}
                                                        placeholder="Write your message here..."
                                                        rows={5}
                                                        className="input resize-none"
                                                        required
                                                    />
                                                </div>

                                                <button
                                                    type="submit"
                                                    disabled={isSubmitting}
                                                    className="btn btn-primary w-full lg:w-auto"
                                                >
                                                    {isSubmitting ? (
                                                        <>
                                                            <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                                                            </svg>
                                                            Sending...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                                            </svg>
                                                            Send Message
                                                        </>
                                                    )}
                                                </button>
                                            </form>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Contact Info Sidebar */}
                            <div className="space-y-4">
                                {contactInfo.map((item, idx) => (
                                    <div key={idx} className="bg-white rounded-xl p-5 shadow-sm">
                                        <div className="flex items-start gap-4">
                                            <span className="text-2xl">{item.icon}</span>
                                            <div>
                                                <h3 className="font-semibold text-gray-900">{item.title}</h3>
                                                {item.link ? (
                                                    <a href={item.link} className="text-primary hover:underline">
                                                        {item.content}
                                                    </a>
                                                ) : (
                                                    <p className="text-gray-600">{item.content}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* Map Placeholder */}
                                <div className="bg-white rounded-xl p-5 shadow-sm">
                                    <h3 className="font-semibold text-gray-900 mb-3">Find Us</h3>
                                    <div className="aspect-video bg-gray-100 rounded-lg flex items-center justify-center">
                                        <div className="text-center text-gray-400">
                                            <svg className="w-10 h-10 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            <p className="text-sm">Map will be displayed here</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
